module.exports = __webpack_public_path__ + "static/media/about-us.61e7309f.png";